module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "toggle",
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-book fa-fw"
  }), _vm._v(" "), (_vm.show) ? _c('span', [_vm._v("\n                Skjul ordforklaring\n                "), _c('i', {
    staticClass: "far fa-chevron-up fa-fw"
  })]) : _c('span', [_vm._v("\n                Vis ordforklaring\n                "), _c('i', {
    staticClass: "far fa-chevron-down fa-fw"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "explainer"
  }, [_c('div', {
    staticClass: "lines"
  }, _vm._l((_vm.abbreviations), function(line) {
    return _c('div', {
      key: line.abb,
      staticClass: "line"
    }, [_c('div', {
      staticClass: "abb"
    }, [_vm._v("\n                        " + _vm._s(line.abb) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "exp"
    }, [_vm._v("\n                        " + _vm._s(line.exp) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "comment"
    }, [_vm._v("\n                        " + _vm._s(line.comment) + "\n                    ")])])
  }), 0)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ebecd11", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebecd11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
// module id = 845
// module chunks = 0